
import React from "react"
import FontAwesome from "react-fontawesome"
import { blockingFetchService } from "../../../lib/blockingFetch"
import authServerApi from "../../../redux/sagas/authServerApi"
import {
  Col,
  Form,
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap'
import { Link, browserHistory } from "react-router"
import Legal from "../../fragments/Legal"
import store from "store"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { connect } from "react-redux"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import './index.css'

class UpdatePassword extends React.Component {

  constructor(props) {
    super(props)

    this.inputRef = null 
    this.setInputRef = elt => {
      this.inputRef = elt
    }
  }

  state = {
    password: '',
    passwordConfirmation: '',
    running: false,
    success: false,
    error: null,
    validationHtml: [],
    showHelp: false,
    passwordStrength: 0,
    showPassword: false,
  }

  validatePassword = () => {
    const { password } = this.state,
    passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()+=-])(?=\\S+$).{8,20}$")
    return password === '' ? null : (passwordRegex.test(password) ? 'success' : 'error')
  }

  validatePasswordConfirmation = () => {
    const { password, passwordConfirmation } = this.state
    return passwordConfirmation === '' ? null : password === passwordConfirmation ? 'success' : 'error'
  }

  analysePassword = password => {

    let digitRegex = new RegExp("^(?=.*[0-9])"),
      upperRegex = new RegExp("^(?=.*[A-Z])"),
      lowerRegex = new RegExp("^(?=.*[a-z])"),
      specialCharRegex = new RegExp("^(?=.*[!@#$%^&*()+=-])"),
      noWhiteSpaceRegex = new RegExp("^(?=\\S+$)"),
      errors = []

    if(password.length < 8 || password.length > 20) {
      errors.push('It must contain at least 8 characters and at most 20 characters.')
    }
    if(!digitRegex.test(password)) {
      errors.push('It must contain at least one digit.')
    }
    if(!upperRegex.test(password)) {
      errors.push('It must contain at least one upper case alphabet.')
    }
    if(!lowerRegex.test(password)) {
      errors.push('It must contain at least one lower case alphabet.')
    }
    if(!specialCharRegex.test(password)) {
      errors.push('It must contain at least one special character which includes !@#$%&*()-+=^')
    }
    if(!noWhiteSpaceRegex.test(password)) {
      errors.push('It doesn\'t contain any white space.')
    }

    return errors
  }

  savePassword = () => {

    this.setState({
      success: false,
      running: false,
      error: null,
      validationHtml: [],
    })

    const { password } = this.state,
    { params } = this.props

    if(this.validatePassword() === 'success' && this.validatePasswordConfirmation() === 'success') {

      this.setState({ running: true })

      blockingFetchService(
        accessToken => authServerApi.updateUserPassword(accessToken, params.userId, password), 
        _ => {
          this.setState({ success: true })
          setTimeout(() => browserHistory.push('/sign-out'), 1000)
        },
        error => this.setState({ error: error.text }),
        _ => this.setState({ running: false })
      )
    }
    else {
      const validationHtml = this.analysePassword(password)
      this.setState({
        error: validationHtml.length ? 'The password is incorrect.' : 'Please check password confirmation',
        validationHtml,
      })
    }
  }

  passwordChanged = newValue => {

    const errorsLength = this.analysePassword(newValue).length,
    newValueLength = newValue.length,
    lengthOfPassword = newValueLength >= 8 && newValueLength <= 20 ? (newValueLength * .5) : 0,
    strength = (16 * (Math.abs(5 - errorsLength))) + lengthOfPassword

    this.setState({
      password: newValue,
      error: null,
      validationHtml: [],
      passwordStrength: newValueLength ? strength : 0,
    })
  }

  passwordConfirmationChanged = value => this.setState({
    passwordConfirmation: value,
    error: null,
  })

  toggleShowPassword = () => {
    if (this.inputRef.focus) {
      this.inputRef.focus()
    }
    this.setState({ showPassword: !this.state.showPassword })
  }

  renderOrganizationDetails = () => {

    const organization = store.get("organization")
    if(!organization) {
      return null
    }

    return  (
      <span title="Organization name">
        { organization.name }&nbsp;
        <img title="Organization icon"
          alt={ organization.name }
          width={22}
          height={22}
          src={ organization.iconId ?
            apiServerApi.organizationIconURL(organization.id) : require('../../../files/company-logo.png')}
        />
      </span>
    )
  }

  render() {
    const { password, passwordStrength, passwordConfirmation, showPassword, 
      running, error, success, validationHtml, showHelp } = this.state
    return (
      <div>
        <div id="header-password">

          <div>
            <Link to="/">
              <img
                className="ml-20"
                src={require("../../../files/logo.png")}
                alt="Logo"
                width={100}
              />
            </Link>
          </div>

          <div id="organization-container">{ this.renderOrganizationDetails() }</div>
        </div>

        <Col mdOffset={3} md={6} id="password-container" >

          <div className="mb-30">
            <h3 className="title-update-password text-xl sm:text-2xl">
              <FontAwesome name='lock' size="2x"/> 
              <br />
              Secure your account.
              <br />
              Set up a new password
            </h3>
          </div>

          <Form horizontal>
            <FormGroup controlId="password" validationState={ this.validatePassword() }>

              <Col sm={2} componentClass={ControlLabel}>
                Choose a password
              </Col>

              <Col sm={8} className="relative">
                <FormControl
                  inputRef={ this.setInputRef }
                  className="h-12 pr-16"
                  type={ showPassword ? 'text' : 'password' }
                  placeholder="Password"
                  value={ password }
                  minLength={8}
                  maxLength={20}
                  autoFocus
                  onChange={e => this.passwordChanged(e.target.value)}
                  disabled={  running || success }
                />
                <div className="show-password right-6" onClick={ this.toggleShowPassword }>
                  { showPassword ? 'Hide' : 'Show' }{' '}
                  <FontAwesome name={ showPassword ? 'eye-slash' : 'eye' } />
                </div>
              </Col>

              <Col sm={2}>
                { passwordStrength > 0 &&
                <div className="mt-3">
                  <span>Strength</span>
                  <meter
                    className="w-100p"
                    min="0" max="100"
                    low="80" high="86" optimum="95"
                    value={ passwordStrength }>
                    Password strength
                  </meter>
                </div>
                }
              </Col>
            </FormGroup>

            <FormGroup controlId="passwordConfirmation" validationState={ this.validatePasswordConfirmation() }>

              <Col sm={2} componentClass={ControlLabel}>
                Password confirmation
              </Col>

              <Col sm={8}>
                <FormControl
                  className="h-12"
                  type={ showPassword ? 'text' : 'password' }
                  placeholder="Confirm your password"
                  value={ passwordConfirmation }
                  minLength={8}
                  maxLength={20}
                  onChange={e => this.passwordConfirmationChanged(e.target.value)}
                  disabled={ running || success }
                />
              </Col>

            </FormGroup>

            <FormGroup>
              <Col smOffset={2} sm={8}>
                <ProcessesStatus
                  error={ error }
                  running={ running }
                  success={ success }
                />

                { validationHtml.length 
                ? <ul className="error-color">
                  { validationHtml.map((value, index) => 
                    <li key={index}>{value}</li>
                  )}
                  </ul>
                : null
                }
              </Col>
            </FormGroup>

            <FormGroup>
              <Col smOffset={2} sm={8}>
                <Button bsStyle="info" onClick={ this.savePassword }
                  disabled={ running || success } id="save-btn">
                  Save
                </Button>
              </Col>
            </FormGroup>

            <FormGroup>
              <Col smOffset={10} sm={2}>
                <div className="cursor-pointer align-right">
                  <span onClick={() => { this.setState({ showHelp: !showHelp })}}>
                    <FontAwesome name='question-circle' size="lg"/>
                  </span>
                </div>
              </Col>
            </FormGroup>

            <FormGroup>
              <Col smOffset={2} sm={10}>
              { showHelp ?
                <div id="helpContainer">
                  <strong>Password requirements</strong>
                  <ul>
                  { this.analysePassword('').map((value, index) =>
                    <li key={index}><FontAwesome name='hand-o-right'/> { value }</li>
                  )}
                  </ul>
                </div>
              : null
              }
              </Col>
            </FormGroup>
          </Form>
        </Col>

        <Col sm={12} className='mt-20'>
          <Legal />
        </Col>
      </div>
    )
  }
}

export default connect()(UpdatePassword)



// WEBPACK FOOTER //
// ./src/components/Users/EditUser/UpdatePassword.js